import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M75 5a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#7B8493"
      d="M97.66 13.262a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
    />
    <path fill="#C7D0D9" d="M7.5 79a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M107.566 25c.828 0 1.5.666 1.5 1.488v14.024c0 .822-.672 1.488-1.5 1.488s-1.5-.666-1.5-1.488V26.488c0-.822.672-1.488 1.5-1.488"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M99 33.567c0-.828.666-1.5 1.488-1.5h14.024c.822 0 1.488.672 1.488 1.5s-.666 1.5-1.488 1.5h-14.024a1.494 1.494 0 0 1-1.488-1.5M30.557 100.536c.586.586.59 1.532.008 2.113l-9.916 9.916a1.493 1.493 0 0 1-2.113-.008 1.494 1.494 0 0 1-.008-2.113l9.916-9.916a1.495 1.495 0 0 1 2.113.008"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M18.442 100.537a1.494 1.494 0 0 1 2.113-.008l9.916 9.915a1.495 1.495 0 0 1-.008 2.114 1.495 1.495 0 0 1-2.113.008l-9.916-9.916a1.494 1.494 0 0 1 .008-2.113"
      clipRule="evenodd"
    />
    <path fill="#ACB8C3" d="M87.362 47.328H30.925v30.354h56.437z" />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M49.648 44.486a2.84 2.84 0 0 1 2.842 2.842v28.884a2.842 2.842 0 1 1-5.684 0V47.328a2.84 2.84 0 0 1 2.842-2.842M30.925 44.486a2.84 2.84 0 0 1 2.842 2.842v28.884a2.842 2.842 0 1 1-5.684 0V47.328a2.84 2.84 0 0 1 2.842-2.842M69.273 44.486a2.84 2.84 0 0 1 2.842 2.842v28.884a2.842 2.842 0 1 1-5.684 0V47.328a2.84 2.84 0 0 1 2.842-2.842M87.362 44.486a2.84 2.84 0 0 1 2.842 2.842v28.884a2.842 2.842 0 1 1-5.684 0V47.328a2.84 2.84 0 0 1 2.842-2.842"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M18.186 77.683a2.84 2.84 0 0 1 2.842-2.842h76.231a2.842 2.842 0 1 1 0 5.684H21.028a2.84 2.84 0 0 1-2.842-2.842"
      clipRule="evenodd"
    />
    <path
      fill="#7B8493"
      fillRule="evenodd"
      d="M12 90c0-1.105.996-2 2.225-2h87.55c1.229 0 2.225.895 2.225 2s-.996 2-2.225 2h-87.55C12.996 92 12 91.105 12 90"
      clipRule="evenodd"
    />
    <path
      fill="#C7D0D9"
      d="M23.535 48.532h71.217c2.705 0 3.764-3.512 1.509-5.007L60.653 19.92a2.73 2.73 0 0 0-3.017 0L22.028 43.525c-2.255 1.495-1.197 5.007 1.509 5.007z"
    />
  </svg>
);
const SvgEnrichedIconAccountingGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconAccountingGreyscale);
export default Memo;
